/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { QrcodeOutlined, SaveOutlined } from '@ant-design/icons';
import { Alert, Button, Col, Form, Input, Row, Select, Spin, Steps, Typography } from 'antd';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import InputTag from '../../components/InputTag';
import LocationSearchLocationIQ from '../../components/LocationSearchLocationIQ';
import regex from '../../constants/system.keys';
import { addExternalDeviceReturn, checkExternalDeviceReturn, socketEmitEvent, } from '../../redux/actions';
import * as SERVICE from '../../constants/service.types';
import { CAMERA_BRAND } from '../../constants';

const { Paragraph } = Typography;


const { Step } = Steps;
const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
};

const { Option } = Select;
const ERROR_CHECK_FACE_TERMINAL = {
  error_unauthorized: {
    field: 'username',
    message: 'Username or password incorrect'
  },
  error_connection: {
    field: 'endpoint',
    message: 'Can not connect to device, please check endpoint'
  }
}

const DEVICE_STATUS = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
}

const AddFaceTerminalComponent = ({
  gatewaySerial,
  checkDeviceReturn,
  onUpdate,
  handleAddSuccessful,
  selectedType
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [requestId, setRequestId] = useState(new Date().getTime());
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [factorySerialInput, setFactorySerialInput] = useState('');
  const [deviceSerial, setDeviceSerial] = useState('');
  const [nameInput, setNameInput] = useState('');
  const [isBlock, setIsBlock] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [address, setAddress] = useState({
    note: '',
  });
  const [alertUpdate, setAlertUpdate] = useState({
    visible: false,
    type: null,
    message: null,
  });
  const { updateDevice, addExternalDevice, namespace } = useSelector((state) => state);
  const [updateReturn, setUpdateReturn] = useState();
  const [addDeviceReturn, setAddDeviceReturn] = useState();
  const serialRef = useRef(null);
  const refHandleTimer = useRef();
  const [handleTimer, setHandleTimer] = useState();
  const [image, setImage] = useState(null);
  const [brand, setBrand] = useState(null);

  const reset = useCallback(() => {
    setIsLoading(false);
    setStep(0);
    setFactorySerialInput('');
    setDeviceSerial('');
    setNameInput('');
    setIsBlock(false);
    setIsLoad(false);
    setAddress({ note: '' });
    setAlertUpdate({ visible: false, type: null, message: null });
    setUpdateReturn(null);
    if (refHandleTimer.current) {
      clearInterval(refHandleTimer.current);
    }
    setHandleTimer(null);
    form.resetFields();
  }, [])

  useEffect(() => {
    if (!selectedType || selectedType !== 'face_terminal') {
      reset();
    }

    return () => {
      reset()
    };
  }, [selectedType, reset]);

  const onCheckFaceTerminal = useCallback(
    (values) => {
      const { username, password, endpoint, brand, gatewayType } = values;
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest)
      setBrand(brand)
      if (username && password && endpoint && gatewaySerial && namespace) {
        let data = {
          username,
          password,
          endpoint,
          gatewaySerial,
          namespace,
          model: brand || '',
          gatewayType: gatewayType || 'premise_box',
        }
        console.log("🚀 ~ AddFaceTerminalComponent ~ data:", data)
        let dataObj = {
          appServiceType: SERVICE.REQUEST_CHECK_FACE_TERMINAL,
          requestId: dataTimeRequest,
          body: JSON.stringify(data),
        }
        return dispatch(socketEmitEvent(dataObj))
      }
    },
    [dispatch, gatewaySerial, namespace]
  )

  useEffect(() => {
    console.log('🚀 ~ AddFaceTerminalComponent ~ checkDeviceReturn:', checkDeviceReturn)
    console.log('🚀 ~ AddFaceTerminalComponent ~ requestId:', requestId)
    if (!checkDeviceReturn || checkDeviceReturn.requestId !== requestId) return
    if (checkDeviceReturn.requestId === requestId) {
      if (refHandleTimer.current) {
        clearInterval(refHandleTimer.current);
      }
      setHandleTimer(null);
      setIsLoading(false);

      if (checkDeviceReturn.result !== 1) {
        form.setFields([
          {
            name: 'username',
            errors: [checkDeviceReturn.message || 'Error when checking face terminal'],
          },
        ]);
        return;
      }
      const data = JSON.parse(checkDeviceReturn?.data)
      if (!data?.deviceStatus || data?.deviceStatus === DEVICE_STATUS.OFFLINE) {
        form.setFields([
          {
            name: 'username',
            errors: [data?.message || 'Device is offline, please check the device!'],
          },
        ]);
        return;
      }
      if (!data?.deviceId || data?.deviceId === 0) {
        form.setFields([
          {
            name: 'username',
            errors: ['Device not found, please check the device!'],
          },
        ]);
        return;
      }
      if (data && data?.serial) {
        if (data?.result && ERROR_CHECK_FACE_TERMINAL?.[data.result]) {
          const fieldError = ERROR_CHECK_FACE_TERMINAL?.[data.result]?.field
          const errorMessage = ERROR_CHECK_FACE_TERMINAL?.[data.result]?.message
          form.setFields([
            {
              name: fieldError,
              errors: [errorMessage || 'Error when checking face terminal'],
            },
          ]);
          return
        }
        const { username, password } = form.getFieldsValue()
        setDeviceSerial(data.serial);
        setImage(data.imageUrl);

        localStorage.setItem('extraInfoFaceTerminal', JSON.stringify(
          {
            localAddress: '',
            name: '',
            brand: '',
            factorySerial: data?.deviceId,
            authenticationRtsp: 'ok',
            source: data?.endpoint ?? '',
            thumbnail: data?.imageUrl,
            username,
            password,
            action: data?.action,
            gatewaySerial: data?.gatewaySerial,
            subSources: JSON.stringify([]),
            accountId: data?.accountId,
          }
        ))
        form.resetFields();
        setStep(1);
        dispatch(checkExternalDeviceReturn(null));
      } else {
        console.log(4);
        form.setFields([
          {
            name: 'username',
            errors: ['Error when checking face terminal'],
          },
        ]);
      }
    }
  }, [checkDeviceReturn, dispatch, form, requestId]);

  useEffect(() => {
    if (handleTimer === 0 && !checkDeviceReturn) {
      setIsLoading(false);
      if (refHandleTimer.current) {
        clearInterval(refHandleTimer.current);
      }
      form.setFields([
        {
          name: 'username',
          errors: [t('Timeout, cannot find face terminal!')],
        },
      ]);
      setHandleTimer(null);
    }
  }, [handleTimer, form, checkDeviceReturn, t]);

  const handleAddFaceTerminal = useCallback((factorySerialInput, name, deviceSerial) => {
    if (name && deviceSerial) {
      let data = {
        serial: deviceSerial,
        namespace,
        deviceType: 'camera',
        extraInfo: {
          ...(JSON.parse(localStorage.getItem('extraInfoFaceTerminal')) || {}),
          name,
          typeCamera: 'face_terminal_camera',
          brand: brand || '',
        }
      };
      localStorage.removeItem('extraInfoFaceTerminal');
      console.log('🚀 ~ AddFaceTerminalComponent ~ data:', data)
      console.log('🚀 ~ AddFaceTerminalComponent ~ JSON.stringify(data):', JSON.stringify(data))
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest);
      let dataObj = {
        appServiceType: SERVICE.REQUEST_ADD_EXTERNAL_DEVICE,
        requestId: dataTimeRequest,
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, brand]);

  const onFinish = useCallback(
    (values) => {
      if (step === 0) {
        console.log("STEP 1 VALIDATE FACTORY SERIAL");
        setIsLoading(true);
        setFactorySerialInput(values.serial);
        form.setFieldsValue({ ...values })

        setHandleTimer(15);
        refHandleTimer.current = setInterval(() => {
          setHandleTimer((timer) => timer - 1);
        }, 1000);

        return onCheckFaceTerminal(values);
      }
      if (step === 1) {
        console.log("STEP 2")
        setNameInput(values.name);
        return handleAddFaceTerminal(factorySerialInput, values.name, deviceSerial);
      }
    },
    [onCheckFaceTerminal, factorySerialInput, step, deviceSerial]
  );

  /////////////////////////////////////////////////////////////

  useEffect(() => {
    if (updateDevice && updateDevice.requestId === requestId) {
      console.log('🚀 ~ AddFaceTerminalComponent ~ updateDevice:', updateDevice)
      setUpdateReturn(updateDevice);
    }
  }, [updateDevice]);

  useEffect(() => {
    return () => {
      setAlertUpdate({ visible: false });
    };
  }, [form]);

  useEffect(() => {
    if (serialRef.current && step === 0) {
      setTimeout(() => {
        serialRef.current.input.focus();
      }, 1);
    }
  }, [serialRef, step]);

  useEffect(() => {
    console.log('🚀 ~ AddFaceTerminalComponent ~ addExternalDevice:', addExternalDevice)
    if (addExternalDevice && addExternalDevice.serial) {
      setIsLoading(false);
      setAddDeviceReturn(addExternalDevice)
      dispatch(addExternalDeviceReturn(null));
      form.setFieldsValue({
        nameDefault: nameInput,
        lastSerial: addExternalDevice.serial,
      });
      setStep(2);
    }
  }, [addExternalDevice, dispatch, form, nameInput, factorySerialInput]);

  const onChangeStep = (value) => {
    if (value > step) return
    form.resetFields();
    setStep((state) => (state > value ? value : state));
  };

  const handleAddressChange = (address) => {
    form.setFieldsValue({
      location: address,
    });
    setAddress((state) => ({
      ...state,
      note: address,
    }));
  };

  const handleSelect = (address) => {
    form.setFieldsValue({
      location: address?.note ?? '',
    });
    setAddress(address);
  };

  useEffect(() => {
    if (updateReturn && updateReturn.serial === deviceSerial) {
      console.log('🚀 ~ AddFaceTerminalComponent ~ updateReturn:', updateReturn)
      setIsLoad(false);
      if (updateReturn.isSuccess) {
        setUpdateReturn(null);
        form.resetFields();
        // handleAddSuccessful();
        setStep(3)
      } else {
        setAlertUpdate({
          visible: true,
          type: 'warning',
          message: t('Something went wrong, try again!!'),
        });
      }
    }
  }, [form, handleAddSuccessful, deviceSerial, t, updateReturn]);

  useEffect(() => {
    console.log('🚀 ~ AddFaceTerminalComponent ~ deviceSerial:', deviceSerial)
  }, [deviceSerial]);

  // Step 2: Update Face Terminal
  const handleOnUpdate = useCallback(
    (values) => {
      if (address && requestId) {
        const data = {
          name: values.nameDefault,
          note: values.location ?? '',
          serial: deviceSerial,
          lat: address.lat ?? 0,
          lng: address.lng ?? 0,
          tags: values.tags?.join(';')?.toLowerCase() || ';',
        };
        const dataTimeRequest = new Date().getTime();
        setRequestId(dataTimeRequest);
        setIsLoad(true);
        return onUpdate(data, dataTimeRequest);
      }
    },
    [address, onUpdate, requestId, deviceSerial]
  );

  if (step === 2) {
    return (
      <div className="edit-gateway-component">
        <div className="steps-add-gateways">
          <Steps
            size="small"
            current={step}
            onChange={onChangeStep}
            type="navigation"
            className="site-navigation-steps"
          >
            <Step title={t('Validate')} />
            <Step title={t('Add')} />
            <Step title={t('Update')} />
            <Step title={t('Configuration Info')} />
          </Steps>
        </div>
        <Form
          form={form}
          {...layout}
          name="form_edit_gateway"
          onFinish={(values) => handleOnUpdate(values)}
        >
          <Form.Item
            name="nameDefault"
            label={t('Name')}
            rules={[
              {
                required: true,
                message: t('Please input the name of gateway!'),
              },
              {
                pattern: regex.isName,
                message: t('Please enter only letters and numbers!'),
              },
              {
                max: 80,
                message: t('Please input up to 80 characters!'),
              },
            ]}
          >
            <Input disabled />
          </Form.Item>
          <Form.Item name="lastSerial" label={t('Serial')}>
            <Input disabled={true} />
          </Form.Item>
          <Form.Item
            name="location"
            rules={[
              {
                pattern: regex.isName,
                message: t('Please enter only letters and numbers!'),
              },
              {
                max: 200,
                message: t('Please input up to 200 characters!'),
              },
            ]}
            label={t('Location')}
          >
            <LocationSearchLocationIQ
              address={address.note}
              onChange={handleAddressChange}
              onAddressSelect={handleSelect}
              setIsBlock={setIsBlock}
            />
          </Form.Item>
          <Form.Item
            name="tags"
            className="tags-device"
            label={t('Tag')}
            style={{ borer: '1px solid #434343', borderRadius: '2px' }}
          >
            <InputTag numberTag={3} nameAdd="Add tag" />
          </Form.Item>
          <div className="edit-gateway-alert">
            {alertUpdate.visible && (
              <Alert
                {...alertUpdate}
                showIcon
                closable
                onClose={() => setAlertUpdate({ visible: false })}
              />
            )}
          </div>
          <div className="btn-update-on-add-gateway">
            <Button onClick={() => {
              // handleAddSuccessful()
              // reset()
              setStep(3)
            }}>{t('Skip')}</Button>
            <Form.Item shouldUpdate>
              {() => (
                <Button
                  icon={<SaveOutlined />}
                  htmlType="submit"
                  type="primary"
                  loading={isLoad}
                  disabled={
                    form.getFieldsError().filter(({ errors }) => errors.length)
                      .length
                  }
                >
                  {t('Update')}
                </Button>
              )}
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }

  return (
    <div className="add-box-component">
      <div className="steps-add-gateways">
        <Steps
          size="small"
          current={step}
          onChange={onChangeStep}
          type="navigation"
          className="site-navigation-steps"
        >
          <Step title={t('Validate')} />
          <Step title={t('Add')} />
          <Step title={t('Update')} />
          <Step title={t('Configuration Info')} />
        </Steps>
      </div>

      {/* step === 0: Validate factory serial */}
      {step === 0 && (
        <div className="title-add-box">
          {t('Enter device info please.')}
        </div>
      )}

      {
        step !== 3 && (
          <div className="main-form-add-box">
            <Form
              form={form}
              // {...(step === 0 ? {} : layout)}
              {...layout}
              name="horizontal_login"
              // layout={step === 0 ? 'inline' : 'horizontal'}
              onFinish={onFinish}
            >
              {step === 0 ? (
                <>
                  {/* <Form.Item
                name="serial"
                label={t('Factory serial')}
                rules={[
                  {
                    required: true,
                    message: t('Please enter the device serial!'),
                  },
                  {
                    len: 16,
                    message: t('Factory Serial must be more than 16 characters!'),
                  },
                  {
                    pattern: /^[a-zA-Z0-9]+$/,
                    message: t('Do not enter special characters, only allow letters and numbers!'),
                  },
                ]}
              >
                <Input
                  ref={serialRef}
                // prefix={<QrcodeOutlined className="site-form-item-icon" />}
                // placeholder={t('Factory serial')}
                />
              </Form.Item> */}
                  <Form.Item
                    name="username"
                    label={t('Username')}
                    rules={[
                      {
                        required: true,
                        message: t('Please enter the username!'),
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    label={t('Password')}
                    rules={[
                      {
                        required: true,
                        message: t('Please enter the password!'),
                      },
                      // {
                      //   pattern: regex.isPassword,
                      //   message: t('Password must be at least 6 characters long and contain letters and numbers!'),
                      // }
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="endpoint"
                    label={t('Endpoint')}
                    rules={[
                      {
                        required: true,
                        message: t('Please enter the endpoint!'),
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="brand"
                    label={t('Brand')}
                    rules={[
                      {
                        required: true,
                        message: t('Please select the brand!'),
                      },
                    ]}
                  >
                    <Select placeholder={t('Select brand')}>
                      {
                        Object.values(CAMERA_BRAND).map((value) => (
                          <Option value={value}>{value}</Option>
                        )
                        )
                      }
                    </Select>
                  </Form.Item>
                </>

              ) : (
                <>
                  {
                    image && (
                      <Form.Item style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img style={{ width: '100%', marginBottom: '10px' }} src={image} alt='' />
                      </Form.Item>
                    )
                  }
                  <Form.Item name="deviceSerial" label={t('Serial')}>
                    <Input
                      defaultValue={deviceSerial}
                      disabled
                      prefix={<QrcodeOutlined className="site-form-item-icon" />}
                    />
                  </Form.Item>
                  <Form.Item
                    name="name"
                    label={t('Name')}
                    rules={[
                      {
                        required: true,
                        message: t('Please input the name of gateway!'),
                      },
                      {
                        pattern: regex.isName,
                        message: t('Please enter only letters and numbers!'),
                      },
                      {
                        max: 80,
                        message: t('Please input up to 80 characters!'),
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </>
              )}
              <div className="btn-update-on-add-gateway">
                <Form.Item shouldUpdate>
                  {() => (
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ marginLeft: '0px' }}
                      loading={isLoading}
                    >
                      {step === 0 ? t('Validate') : t('Create')}
                    </Button>
                  )}
                </Form.Item>
              </div>
            </Form>
          </div>
        )
      }
      {step === 3 && (
        <Spin spinning={!addDeviceReturn}>
          <Form
            layout="horizontal"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
          >
            <Form.Item label="IP Address">
              <Paragraph copyable={{ text: addDeviceReturn?.ipAddress }}>
                <Input
                  style={{ width: '80%', marginRight: '5%' }}
                  disabled
                  value={addDeviceReturn?.ipAddress}
                />
              </Paragraph>
            </Form.Item>

            <Form.Item label="Port">
              <Paragraph copyable={{ text: addDeviceReturn?.port }}>
                <Input
                  style={{ width: '80%', marginRight: '5%' }}
                  disabled
                  value={addDeviceReturn?.port}
                />
              </Paragraph>
            </Form.Item>

            <Form.Item label="URL">
              <Paragraph copyable={{ text: addDeviceReturn?.url }}>
                <Input
                  style={{ width: '80%', marginRight: '5%' }}
                  disabled
                  value={addDeviceReturn?.url}
                />
              </Paragraph>
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 4 }}>
              <Row justify="end">
                <Button
                  type="primary"
                  onClick={() => {
                    handleAddSuccessful();
                  }}
                >
                  Done
                </Button>
              </Row>
            </Form.Item>
          </Form>
        </Spin>
      )}
    </div>
  )
}

export default AddFaceTerminalComponent